import { useState } from 'react';

// Redux & Action
import { useDispatch } from 'react-redux';
import { reloadCredit } from "@core/redux/actions/home/index";

// Icon
import AutorenewIcon from '@mui/icons-material/Autorenew';

export default function ReloadBlance({ homeData, style }) {
    const [spin, setSpin] = useState(false);
    const dispatch = useDispatch();

    const ReloadBlance = () => {
        setSpin(true);
        dispatch(reloadCredit(homeData, setSpin));
    };

    return <AutorenewIcon className={spin ? "iconBalanceReloadSize spin" : "iconBalanceReloadSize refresh"} style={style} onClick={ReloadBlance} />;
}